import { render, staticRenderFns } from "./MyDeals.vue?vue&type=template&id=2bc39df0&lang=pug&"
import script from "./MyDeals.vue?vue&type=script&lang=ts&"
export * from "./MyDeals.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports